const realpressQuickSetupNotification = () => {
	const notificactionNode = document.querySelector( '#notice-install' );

	if ( ! notificactionNode ) {
		return;
	}

	notificactionNode.querySelector( 'button' ).addEventListener( 'click', function() {
		notificactionNode.remove();
	} );
};

export default realpressQuickSetupNotification;
